<template>
  <div class="dealer-details area-trends">
    <VillagesTopNav @leftIconFun="()=>{this.$router.go(-1);}">
      <h2 slot="content">经销商明细</h2>
    </VillagesTopNav>
    <van-tabs>
      <van-tab title="重消币明细">
        <div class="border"></div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="5"
          :immediate-check="false"
          @load="onLoad()"
        >
          <payDetails :data="payData"></payDetails>
        </van-list>
      </van-tab>
      <van-tab title="他的进经销商">
        <div class="border"></div>
        <van-list
          v-model="loading2"
          :finished="finished2"
          finished-text="没有更多了"
          offset="5"
          :immediate-check="false"
          @load="onLoad2()"
        >
          <delaerInfo :data="data" type="left" :show='false'></delaerInfo>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import VillagesTopNav from "../../components/VillagesTopNav.vue";
import delaerInfo from "../../components/delaerInfo.vue";
import payDetails from "../../components/payDetails.vue";
export default {
  data() {
    return {
      data: [
        
      ],
      payData: [
        
      ],

      loading: false,
      finished: false,
      loading2: false,
      finished2: false,
      page_no2: 1,
      page_size2: 10,
      page_no: 1,
      page_size: 10,
      member_id: ""
    };
  },
  components: {
    VillagesTopNav,
    delaerInfo,
    payDetails
  },
  created() {
    this.member_id = this.$route.query.member_id;
    this.hqcxb();
    this.getDealerList();
  },
  mounted() {
    console.log();
  },

  methods: {
    onLoad() {
      this.page_no = this.page_no + 1;
      this.hqcxb();
    },
    onLoad2() {
      this.page_no2 = this.page_no2 + 1;
      this.getDealerList();
    },

    getDealerList() {
        debugger
      let param = {
        page_no: this.page_no,
        page_size: this.page_size,
        member_id: this.member_id
      };
      this.getRequest(`members/myMembers`, param).then(res => {
        console.log(res);
         
        if (res.data.code == 1) {
          this.data = [];
          this.finished2 = true;
        } else {
          this.loading2 = false;
          // 数据全部加载完成
          if (res.data.data.length < 10) {
            this.finished2 = true;
          }
          this.data = this.data.concat(res.data.data);
        }
      });
    },

    hqcxb() {
      this.getRequest(`members/points`, {
        page_no: this.page_no,
        page_size: this.page_size,
        member_id: this.member_id
      }).then(res => {
        if (res.data.code == 1) {
          this.payData = [];
          this.finished = true;
        } else {
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.data.length < 10) {
            this.finished = true;
          }
          this.payData = this.data.concat(res.data.data.data);
        }
      });
    }
  }
};
</script>
<style scoped>
.dealer-details {
  background-color: #fff;
}
.dealer-details .border {
  height: 20px;
  background-color: #f5f5f5;
}
h2 {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 50px;
}
</style>
<style>
.area-trends .van-tab--active .van-tab__text {
  font-size: 30px;
  color: #ff1919;
}
.area-trends .van-tab--active {
  color: #ff1919;
}
.qiehuan-img {
  width: 26px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 10px;
  position: relative;
  top: -3px;
}
.area-trends .van-tabs__nav .van-tab__text {
  font-size: 28px;
  line-height: 90px;
  font-family: pingFangSC-Medium;
}

.area-trends .van-tabs__nav .van-tabs__line {
  width: 48px !important;
  height: 6px !important;
  background: linear-gradient(to right, #f00f00, #ff9176, #ffddd4);
}
</style>